import { Modal, Row, Col, Typography, Tag, Button, Divider } from "antd";
import { EyeOutlined } from '@ant-design/icons';
const { Text, Paragraph } = Typography;

export default function NovedadViewModal({ open, onOpenChange, novedad }) {
    const handleClose = () => onOpenChange(false);
    if (!open || !novedad) return null;

    const tiposNovedadMap = {
        1: 'Falleció',
        2: 'Desistió',
        3: 'Cambio de domicilio',
        4: 'Otros',
    };
    const renderSoporte = (soporte, cedula) => {
        const isPDF = soporte.nombre_real?.toLowerCase().endsWith(".pdf");
        const fileUrl = `/DocumentosFAO/Novedades_Participantes/${cedula}/${soporte.nombre_servidor}`;

        // Elimina el código inicial hasta el primer guión "-"
        const fileName = soporte.nombre_servidor.replace(/^[^-]+-/, "");

        const handleDownload = () => {
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = fileName;  // Nombre limpio
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        return (
            <div
                key={soporte.id}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 10,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    marginBottom: 8,
                    backgroundColor: "#fff",
                    flexWrap: "wrap",
                }}
            >
                <Text style={{ flex: 1 }}>{soporte.nombre_real}</Text>
                <div style={{ display: "flex", gap: 8 }}>
                    {isPDF && (
                        <Button
                            size="small"
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => window.open(fileUrl, "_blank")}
                        >
                            Ver archivo
                        </Button>
                    )}
                    <Button size="small" type="default" onClick={handleDownload}>
                        Descargar
                    </Button>
                </div>
            </div>
        );
    };


    return (
        <Modal
            open={open}
            onCancel={handleClose}
            title="📋 Detalles de la Novedad"
            width={820}
            footer={[
                <Button key="close" type="primary" onClick={handleClose}>
                    Cerrar
                </Button>,
            ]}
            styles={{
                body: {
                    maxHeight: "70vh",
                    overflowY: "auto",
                    paddingRight: 24,
                },
            }}
        >
            <Row gutter={[16, 12]}>
                <Col span={12}>
                    <Text strong>Participante:</Text>
                    <div>{novedad.participante}</div>
                </Col>
                <Col span={12}>
                    <Text strong>Cédula:</Text>
                    <div>{novedad.cedula}</div>
                </Col>
                    <Col span={12}>
                    <Text strong>Proyecto:</Text>
                    <div>{novedad.proyecto}</div>
                </Col>
                <Col span={12}>
                    <Text strong>Departamento:</Text>
                    <div>{novedad.departamento}</div>
                </Col>
                <Col span={12}>
                    <Text strong>Municipio:</Text>
                    <div>{novedad.municipio}</div>
                </Col>
                <Col span={12}>
                    <Text strong>Tipo de Criterios :</Text>
                    <div>
                        <Tag color="blue">{tiposNovedadMap[parseInt(novedad.tipo_novedad)] || "Desconocido"}</Tag>
                    </div>
                </Col>
                <Col span={12}>
                    <Text strong>Reemplazo :</Text>
                    <div>
                        <Tag color={novedad.estado_remplazo === 0 ? "blue" : "green"}>
                            {novedad.estado_remplazo === 0 ? "Sin reemplazo" : "Reemplazado"}
                        </Tag>

                    </div>
                </Col>
                {novedad.nombre_reemplazo && (<Col span={12}>
                    <Text strong>Nombre de Reemplazo:</Text>
                    <div>{novedad.nombre_reemplazo || "Sin reemplazo"}</div>
                </Col>)}

                <Col span={12}>
                    <Text strong>Fecha de Registro:</Text>
                    <div>{novedad.fechaRegistro}</div>
                </Col>

            </Row>
            <Divider />
            <div style={{ marginBottom: 20 }}>
                <Text strong>🗒️ Observación:</Text>
                <Paragraph
                    style={{
                        backgroundColor: "#fafafa",
                        padding: 12,
                        borderRadius: 6,
                        border: "1px solid #f0f0f0",
                    }}
                >
                    {novedad.observacion || <i>(Sin observaciones)</i>}
                </Paragraph>
            </div>
            <div>
                <Text strong>Soportes de la novedad ({novedad.soportes.length}):</Text>
                <div style={{ marginTop: 10 }}>
                    {novedad.soportes.map((soporte) => renderSoporte(soporte, novedad.cedula))}
                </div>
            </div>
            {novedad.nombre_reemplazo && (
                <div>
                    <Text strong>Soportes de reemplazo ({novedad.soportes_reemplazo.length}):</Text>
                    <div style={{ marginTop: 10 }}>
                        {novedad.soportes_reemplazo.map((soporte) => renderSoporte(soporte, novedad.cedula))}
                    </div>
                </div>)}
        </Modal>
    );
}
